(function() {
        let currentSlide = 0;
        const track = document.getElementById('slider-track');
        const dots = document.querySelectorAll('.gallery-dot');
        const slides = track ? track.children : [];
        const totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0) ? wp_total_images : (window.product_data?.images?.length || slides.length || 1);

        function updateSlider() {
          if (track) track.style.transform = `translateX(-${currentSlide * 100}%)`;
          dots.forEach((dot, i) => {
            dot.classList.toggle('bg-cyan-400', i === currentSlide);
            dot.classList.toggle('bg-slate-600', i !== currentSlide);
          });
        }
        window.slideGallery = function slideGallery(dir) {
          currentSlide = (currentSlide + dir + totalSlides) % totalSlides;
          updateSlider();
        };
        window.goToSlide = function goToSlide(index) {
          currentSlide = Math.max(0, Math.min(index, totalSlides - 1));
          updateSlider();
        };
        if (track) {
          let touchStartX = 0;
          let touchEndX = 0;
          track.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
          }, {
            passive: true
          });
          track.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            if (touchStartX - touchEndX > 50) window.slideGallery(1);
            if (touchEndX - touchStartX > 50) window.slideGallery(-1);
          }, {
            passive: true
          });
        }
      })();
      (function() {
        const reviewImages = document.querySelectorAll('#reviews .grid img');
        const reviewSlider = document.getElementById('review-slider');
        const sliderImage = document.getElementById('slider-image');
        const sliderUser = document.getElementById('slider-user');
        const sliderStars = document.getElementById('slider-stars');
        const sliderCounter = document.getElementById('slider-counter');
        let currentReview = 0;
        const totalReviews = reviewImages.length;

        function updateReviewSlider() {
          if (!totalReviews || !sliderImage || !sliderUser || !sliderStars || !sliderCounter) return;
          const img = reviewImages[currentReview];
          if (!img) return;
          sliderImage.src = img.src.replace('w=400&h=400', 'w=600&h=600');
          sliderUser.textContent = img.dataset.user || '';
          const rating = parseInt(img.dataset.rating || '5', 10);
          sliderStars.innerHTML = Array(5).fill(0).map((_, i) => `
																					<i class="fa-${i < rating ? 'solid' : 'regular'} fa-star">
																					</i>`).join('');
          sliderCounter.textContent = `${currentReview + 1} / ${totalReviews}`;
        }
        window.openReviewSlider = function openReviewSlider(index) {
          if (!reviewSlider || !totalReviews) return;
          currentReview = Math.max(0, Math.min(index, totalReviews - 1));
          updateReviewSlider();
          reviewSlider.classList.remove('hidden');
          document.body.style.overflow = 'hidden';
        };
        window.closeReviewSlider = function closeReviewSlider() {
          if (!reviewSlider) return;
          reviewSlider.classList.add('hidden');
          document.body.style.overflow = '';
        };
        window.prevReviewSlide = function prevReviewSlide() {
          if (!totalReviews) return;
          currentReview = (currentReview - 1 + totalReviews) % totalReviews;
          updateReviewSlider();
        };
        window.nextReviewSlide = function nextReviewSlide() {
          if (!totalReviews) return;
          currentReview = (currentReview + 1) % totalReviews;
          updateReviewSlider();
        };
        if (reviewSlider) {
          reviewSlider.addEventListener('click', (e) => {
            if (e.target === reviewSlider) window.closeReviewSlider();
          });
          let touchSX = 0;
          let touchSY = 0;
          reviewSlider.addEventListener('touchstart', (e) => {
            touchSX = e.changedTouches[0].screenX;
            touchSY = e.changedTouches[0].screenY;
          }, {
            passive: true
          });
          reviewSlider.addEventListener('touchend', (e) => {
            const dx = e.changedTouches[0].screenX - touchSX;
            const dy = e.changedTouches[0].screenY - touchSY;
            if (Math.abs(dx) > Math.abs(dy)) {
              if (dx > 50) window.prevReviewSlide();
              if (dx < -50) window.nextReviewSlide();
            } else if (dy > 80) {
              window.closeReviewSlider();
            }
          }, {
            passive: true
          });
        }
      })();
      window.toggleFaq = function toggleFaq(btn) {
        const item = btn?.parentElement;
        if (!item) return;
        const content = item.querySelector('.faq-content');
        const isActive = item.classList.contains('active');
        document.querySelectorAll('.faq-item').forEach((faq) => {
          faq.classList.remove('active');
          const faqContent = faq.querySelector('.faq-content');
          if (faqContent) faqContent.classList.add('hidden');
        });
        if (!isActive && content) {
          item.classList.add('active');
          content.classList.remove('hidden');
        }
      };
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (typeof window.closeReviewSlider === 'function') window.closeReviewSlider();
        }
        const reviewSlider = document.getElementById('review-slider');
        if (!reviewSlider || reviewSlider.classList.contains('hidden')) return;
        if (e.key === 'ArrowLeft' && typeof window.prevReviewSlide === 'function') window.prevReviewSlide();
        if (e.key === 'ArrowRight' && typeof window.nextReviewSlide === 'function') window.nextReviewSlide();
      });
